"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({ error }) {
  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <html>
      <body>
        <NextError />
      </body>
    </html>
  );
}
